/**
 * Convert Unix timestamp (seconds) to "YYYY-MM-DD HH:mm" format for API requests
 * @param timestamp Unix timestamp in seconds
 * @returns Formatted date string "YYYY-MM-DD HH:mm"
 */
export const timestampToApiFormat = (timestamp: number): string => {
  const date = new Date(timestamp * 1000);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  
  return `${year}-${month}-${day} ${hours}:${minutes}`;
};

/**
 * Convert "YYYY-MM-DD HH:mm" format to Unix timestamp (seconds)
 * @param dateString Date string in "YYYY-MM-DD HH:mm" format
 * @returns Unix timestamp in seconds
 */
export const apiFormatToTimestamp = (dateString: string): number => {
  return Math.floor(new Date(dateString.replace(' ', 'T')).getTime() / 1000);
};

/**
 * Split "YYYY-MM-DD HH:mm" into date and time parts
 * @param dateTimeString Date string in "YYYY-MM-DD HH:mm" format
 * @returns Object with date (YYYY-MM-DD) and time (HH:mm) parts
 */
export const splitDateTime = (dateTimeString: string): { date: string; time: string } => {
  const [date, time] = dateTimeString.split(' ');
  return { date: date || '', time: time || '' };
};

/**
 * Combine date and time parts into "YYYY-MM-DD HH:mm" format
 * @param date Date string in "YYYY-MM-DD" format
 * @param time Time string in "HH:mm" format
 * @returns Combined date-time string "YYYY-MM-DD HH:mm"
 */
export const combineDateTime = (date: string, time: string): string => {
  return `${date} ${time}`;
};

